export class SupportSediment {
    Vases: boolean;
    SedimentsFins: boolean;
    DebrisOrganiquesGrossiers: boolean;
    Sables: boolean;
    Granulats: boolean;
    Pierres: boolean;

    static mapFromJSON(json: any): SupportSediment {
        const s = new SupportSediment();
        s.Vases = json.vases;
        s.SedimentsFins = json.sedimentsFins;
        s.DebrisOrganiquesGrossiers = json.debrisOrganiquesGrossiers;
        s.Sables = json.sables;
        s.Granulats = json.granulats;
        s.Pierres = json.pierres;
        return s;
    }
}